import _ from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import { defaults, Pie } from 'react-chartjs-2';
import Color from 'color';

import logo from '../../assets/images/logos/Logo-Color@2x.png';

import { toTitleCase, colorForCategory, getCategoryComponents, getDimensionIdForTalent, getScoreClassificationInOrderedGroupScores } from '../../util';
import { getOrderedUserStrengthsFromAllScores, getUserDataFromAllUsers } from '../../util/data';
import { introForPlanYourCareer, introForPlayToYourStrengths, descriptionForPlayToStrengthsTalent, descriptionForPlayToStrengthsCategory, descriptionForTalentCategoryStrength, descriptionForTalentCategoryWeakness, descriptionForTalent, descriptionForTalentCategory, descriptionForCompetency, descriptionForPlayToStrengthsTalentCategory } from '../../util/descriptions';
import { iconForTalentCategory } from '../../util/icons';

const PAGE_OFFSET = 3;

// Disable animating charts by default.
defaults.pie.animation.animateRotate = false;
defaults.pie.animation.animateScale = false;
defaults.global.tooltips.enabled = false;
//defaults.global.elements.arc.borderWidth = 0;
defaults.global.elements.arc.backgroundColor = 'rgba(0,0,0,.1)';

const TALENT_CATEGORIES=[{
  name: 'Motivation',
  id: 'motivation'
},{
  name: 'Interaction',
  id: 'interaction'
},{
  name: 'Execution',
  id: 'execution'
},{
  name: 'Cognition',
  id: 'cognition'
}];

class ReportPage extends Component {

  state = {
    ProfileID: null
  }

  componentWillMount(){
    const { match: { params } } = this.props;

    this.setState({
      ProfileID: params.ProfileID
    });
  }
  componentDidMount(){

  }

  renderLoadingMessage(){
    return <p>Loading...</p>;
  }

  dataForProfile(){

    //const orderedScores =

    // const strengths = getOrderedUserStrengthsFromAllScores(this.props.scores);
    // getUserScoresFromAllScores
    // const scores = this.props.scores;

    const ProfileID = this.state.ProfileID;

    const strengths = getOrderedUserStrengthsFromAllScores(ProfileID, this.props.scores);
    const matchingUserData = getUserDataFromAllUsers(ProfileID, this.props.users);

    console.log('data for profile calculating...');
    console.log(ProfileID);
    console.log(strengths);

    if(!strengths || !matchingUserData){
      return null;
    }

    return {
      user: matchingUserData,
      strengths: strengths,
    }
  }

  componentWillReceiveProps(){

  }

  renderPieChart(chartData){
    return <Pie legend={{display:false}} ref='chart' options={{maintainAspectRatio:false}} data={chartData} />
  }

  orderedTalentCategories(){
    const strengthScores = this.dataForProfile().strengths;

    return strengthScores;
  }

  chartDataForCategory(category = 'all'){

    if(category === 'all'){
      const orderedTalentCategories = this.orderedTalentCategories();

      return {
        datasets: [{
          data: _.map(orderedTalentCategories, 'percent'),
          backgroundColor: _.map(_.map(orderedTalentCategories, 'id'), colorForCategory)
        }]
      }
    }
    else{
      const categoryColor = Color(colorForCategory(category.id));

      return {
        datasets: [{
          data: _.map(category.talents, 'percent'),
          backgroundColor: [categoryColor.rgb().string(), categoryColor.fade(.2).rgb().string(), categoryColor.fade(.4).rgb().string(), categoryColor.fade(.6).rgb().string(), categoryColor.fade(.8).rgb().string()]
        }]
      }
    }
  }

  renderStrengthsScores(){
    const categories = this.orderedTalentCategories();

    return(
      <div className="strengths-scores tall">
        <div className="pie">
          <div className="chart-container">
            {this.renderPieChart(this.chartDataForCategory('all'))}
          </div>
        </div>

        {_.map(categories, category => {

          const categoryScoreClassification = getScoreClassificationInOrderedGroupScores(category.percent, _.map(categories, 'percent'));

          return (
            <div key={category.id} className={`strength ${category.id}`}>
              <div className="name">{category.name}</div>
              <div className="percent" style={{color: colorForCategory(category.id)}}>{Math.round(category.percent)}%</div>
              {categoryScoreClassification === 'high' &&
                <div className="strong-indicator" style={{backgroundColor: colorForCategory(category.id)}}>Strong Category</div>
              }
              {categoryScoreClassification === 'low' &&
                <div className="strong-indicator" style={{backgroundColor: colorForCategory(category.id)}}>Weak Category</div>
              }
            </div>
          );
        })}
      </div>
    )
  }

  renderScoresForCategory(category){

    return(
      <div className="strengths-scores tall">
        <div className="pie">
          <div className="chart-container">
            {this.renderPieChart(this.chartDataForCategory(category))}
          </div>
        </div>

        {_.map(category.talents, (talent, index) => {

          const talentScoreClassification = getScoreClassificationInOrderedGroupScores(talent.percent, _.map(category.talents, 'percent'));

          return (
            <div key={talent.name} className={`strength ${talent.name}`}>
              <div className="name">{talent.name}</div>
              <div className="percent">{Math.round(talent.percent)}%</div>
                {talentScoreClassification === 'high' &&
                  <div className="strong-indicator" style={{backgroundColor: colorForCategory(category.id)}}>Strong Talent</div>
                }
                {talentScoreClassification === 'low' &&
                  <div className="strong-indicator" style={{backgroundColor: colorForCategory(category.id)}}>Weak Talent</div>
                }
            </div>
          );
        })}
      </div>
    )
  }

  renderSingleScorePie(percentage, color){
    const dataForPie = {
      datasets: [{
        data: [percentage, (100 - percentage)],
        backgroundColor: [color,'rgba(0,0,0,.1)'],
      }]
    }

    return <Pie legend={{display:false}} ref='chart' options={{maintainAspectRatio:false}} data={dataForPie} />
  }

  getScoreLabel(score, isCategory, scoreClassification = false){

    const roundedScore = Math.round(score);

    if(!scoreClassification){
      return roundedScore + '%';
    }
    else if(scoreClassification === 'high'){
      return roundedScore + '% - Strong ' + (isCategory ? 'category' : 'talent');
    }
    else if(scoreClassification === 'low'){
      return roundedScore + '% - Weak ' + (isCategory ? 'category' : 'talent');
    }
    else{
      return roundedScore + '%';
    }
  }

  renderTalentCategories(){

    const categories = this.orderedTalentCategories();

    return(
      <div className="talents">
        {_.map(categories, (category, index) => {

          const categoryScoreClassification = getScoreClassificationInOrderedGroupScores(category.percent, _.map(categories, 'percent'));
          const categoryTalents = getCategoryComponents(category.id);
          const categoryTalentsAsString = _.reduce(categoryTalents, function(memo, talent, index){
            if(index > 0){
              return memo + ', ' + toTitleCase(talent);
            }
            else{
              return toTitleCase(talent);
            }
          }, '');

          return (
            <div key={'category-definition-' + category.id} className="talent">
              <div className="talent-summary">
                <div className="talent-name">{category.name}</div>
                <div className="chart-container">
                  {this.renderSingleScorePie(category.percent, colorForCategory(category.id))}
                </div>
                <div className="percent" style={{color: colorForCategory(category.id)}}>{this.getScoreLabel(category.percent, true, categoryScoreClassification)}</div>
              </div>
              <div className="talent-info">
                <p>{descriptionForTalentCategory(category.id)}</p>
                {categoryScoreClassification === 'high' &&
                  <p>{descriptionForTalentCategoryStrength(category.id)}</p>
                }
                {categoryScoreClassification === 'low' &&
                  <p>{descriptionForTalentCategoryWeakness(category.id)}</p>
                }
                <p className="competency">&gt; &nbsp;Predictive {category.name} Sales Talents: {categoryTalentsAsString}</p>
              </div>
            </div>
          )
        })}
      </div>
    )
  }

  renderTalentsForCategory(category){
    return(
      <div className="talents">
        {_.map(category.talents, talent => {

          const talentScoreClassification = getScoreClassificationInOrderedGroupScores(talent.percent, _.map(category.talents, 'percent'));

          return (
            <div key={'category-definition-' + talent.id} className="talent">
              <div className="talent-summary">
                <div className="talent-name">{talent.name}</div>
                <div className="chart-container">
                  {this.renderSingleScorePie(talent.percent, colorForCategory(category.id))}
                </div>
                <div className="percent" style={{color: colorForCategory(category.id)}}>{this.getScoreLabel(talent.percent, false, talentScoreClassification)}</div>
              </div>
              <div className="talent-info">
                <p>{descriptionForTalent(talent.id)}</p>
                <p className="competency">&gt; &nbsp;Competency: {descriptionForCompetency(talent.id)}</p>
              </div>
            </div>
          )
        })}
      </div>
    )
  }

  renderFooterForPage(pageNumber){
    return (
      <div className="page-footer">
        {this.renderPreparedForUser()}
        {this.renderPageNumber(pageNumber)}
      </div>
    )
  }

  renderPreparedForUser(){
    const dataForProfile = this.dataForProfile();

    const {FirstName, LastName} = dataForProfile.user;

    return (
      <div className="prepared-for">Prepared for {FirstName} {LastName}</div>
    )
  }

  renderPageNumber(number){
    return (
      <div className="page-marker">Page {number}</div>
    )
  }

  renderCategoryPage(category, index){
    return (
      <div key={'page-' + category.id} className="report-know-your-strengths report-page">
        <img className="report-logo" width="150" height="40" src={logo} />
        <h2>{category.name} Talents</h2>
        {this.renderScoresForCategory(category)}
        {this.renderTalentsForCategory(category)}
        {this.renderFooterForPage(index + 2 + PAGE_OFFSET)}
      </div>
    )
  }

  renderPlayToYourStrengthsReport(dataForProfile){

    const orderedTalentCategories = this.orderedTalentCategories();

    return (
      <template>
        <div className="page report-export">
          <div className="report-play-to-your-strengths report-page">
            <img className="report-logo" width="150" height="40" src={logo} />
            <h1>Play To Your Strengths<br/><span className="prepared-for" style={{textTransform: 'capitalize'}}>{dataForProfile.user.FirstName + ' ' + dataForProfile.user.LastName}</span></h1>
            <div className="report-section" style={{paddingTop: '0px'}} dangerouslySetInnerHTML={{__html: introForPlanYourCareer()}}></div>
            <div className="report-section full-width-with-icon">
              <div className="section-icon">{iconForTalentCategory(orderedTalentCategories[0].id)}</div>
              <div className="section-title">Your leading VELOCITY.win category: {orderedTalentCategories[0].name}</div>
              <div className="section-content large-font" dangerouslySetInnerHTML={{__html: descriptionForPlayToStrengthsTalentCategory(orderedTalentCategories[0].id)}}></div>
            </div>
            <div className="report-section no-bottom-border">
              <p>The next page will break down your top talent in each core area of impact. These are strengths that you draw upon to deliver in each core area of impact. Based on your responses to the talent inventory the following strategies have been custom created for you, based on your leading talent for each core area...</p>
            </div>
            {dataForProfile && this.renderFooterForPage(6 + PAGE_OFFSET)}
          </div>
        </div>

        <div className="page report-export">
          <div className="report-play-to-your-strengths report-page">
            <img className="report-logo" width="150" height="40" src={logo} />
            <h1>Play To Your Strengths<br/><small className="prepared-for" style={{textTransform: 'capitalize'}}>{dataForProfile.user.FirstName + ' ' + dataForProfile.user.LastName}</small></h1>

            {_.map(orderedTalentCategories, (talentCategory, index) => {
              return (
                <div key={'top-talent-definition-for-category-' + talentCategory.id} className={'report-section has-icon ' + (index === 3 ? 'no-bottom-border' : '')}>
                  <div className="section-icon">{iconForTalentCategory(talentCategory.id)}</div>
                  <div className="section-title">Top {talentCategory.name} Talent: {talentCategory.talents[0].name}</div>
                  <div className="section-content" dangerouslySetInnerHTML={{__html: descriptionForPlayToStrengthsTalent(talentCategory.talents[0].id)}}></div>
                </div>
              );
            })}
            {dataForProfile && this.renderFooterForPage(7 + PAGE_OFFSET)}
          </div>
        </div>
      </template>
    )
  }

  renderKnowYourStrengthsReport(dataForProfile){
    return (
      <div className="page report-export">
        <div className="report-know-your-strengths report-page">
          <img className="report-logo" width="150" height="40" src={logo} />
          <h1>Know Your Strengths<br/><span className="prepared-for" style={{textTransform: 'capitalize'}}>{dataForProfile.user.FirstName + ' ' + dataForProfile.user.LastName}</span></h1>
          {dataForProfile && this.renderStrengthsScores()}
          {dataForProfile && this.renderTalentCategories()}
          {dataForProfile && this.renderFooterForPage(1 + PAGE_OFFSET)}
        </div>

        {dataForProfile && _.map(this.orderedTalentCategories(), this.renderCategoryPage.bind(this))}

        {!dataForProfile && this.renderLoadingMessage()}
      </div>
    )
  }

  render(){

    const dataForProfile = this.dataForProfile();

    if(!dataForProfile || !dataForProfile.user){
      return null;
    }

    return (
      <div>
        {this.renderKnowYourStrengthsReport(dataForProfile)}
        {this.renderPlayToYourStrengthsReport(dataForProfile)}
      </div>
    )
  }
}

function mapStateToProps(state){
  return {
    users: state.users,
    //scores: state.scores,
    //TODO reduce the amount of data fetched here...
    // currentUser: state.currentUser,
    // scoresForCurrentUser: state.scoresForCurrentUser,
  }
}

export default connect(mapStateToProps, {})(ReportPage);



// WEBPACK FOOTER //
// ./src/components/report_deprecated/index.js